var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7613 3.26541C14.3996 2.90346 13.97 2.61633 13.4972 2.42043C13.0244 2.22453 12.5177 2.1237 12.0059 2.1237C11.4942 2.1237 10.9874 2.22453 10.5146 2.42043C10.0418 2.61633 9.6123 2.90346 9.25051 3.26541L8.49968 4.01625L7.74884 3.26541C7.01806 2.53463 6.02691 2.12408 4.99343 2.12408C3.95994 2.12408 2.96879 2.53463 2.23801 3.26541C1.50723 3.99619 1.09668 4.98735 1.09668 6.02083C1.09668 7.05431 1.50723 8.04546 2.23801 8.77625L2.98884 9.52708L8.49968 15.0379L14.0105 9.52708L14.7613 8.77625C15.1233 8.41446 15.4104 7.98491 15.6063 7.51212C15.8022 7.03934 15.9031 6.53259 15.9031 6.02083C15.9031 5.50907 15.8022 5.00232 15.6063 4.52954C15.4104 4.05675 15.1233 3.6272 14.7613 3.26541Z",
    fill: "#FF5917"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.c07f537801fcaee2f7766616a91367d6.svg";
export { ForwardRef as ReactComponent };